












import {
  Component,
  Vue,
  Prop,
} from 'vue-property-decorator'
import { Assessment } from '@/models/Operation'
import locales from '@/../locales/intterra-ru-RU.json'


@Component
export default class OperationsAssessment extends Vue {
  @Prop(Number)
  public assessment!: Assessment;

  public get type() {
    const { assessment } = this
    if (typeof assessment !== 'number') return 'no-assessment'
    return Assessment[assessment] || assessment
  }

  public get label() {
    const { assessment } = this
    if (typeof assessment !== 'number') return 'Нет оценки'
    const key = Assessment[assessment] as keyof typeof Assessment
    return (key in locales) ? locales[key] : assessment
  }
}
